import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const SecretCode = () => import('@/views/pages/SecretCode')
const Keycloak = () => import('@/views/pages/Keycloak')
const ForgetPassword = () => import('@/views/pages/ForgetPassword')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const Register = () => import('@/views/pages/Register')
const Logout = () => import('@/views/pages/Logout')

// Users
//const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')


const Entities = () => import('@/views/models/entities/Entities')
const EntitiesNews = () => import('@/views/models/entities/EntitiesNews')
const EntitiesEdit = () => import('@/views/models/entities/EntitiesEdit')
const EntitiesShow = () => import('@/views/models/entities/EntitiesShow')

const Agences = () => import('@/views/models/agences/Agences')
const AgencesByEntity = () => import('@/views/models/agences/AgencesByEntity')
const AgencesNews = () => import('@/views/models/agences/AgencesNews')
const AgencesOwn = () => import('@/views/models/agences/AgencesOwn')
const AgencesEdit = () => import('@/views/models/agences/AgencesEdit')
const AgencesShow = () => import('@/views/models/agences/AgencesShow')

const Guichets = () => import('@/views/models/guichets/Guichets')
const GuichetsOwn = () => import('@/views/models/guichets/GuichetsOwn')
const GuichetsAgency = () => import('@/views/models/guichets/GuichetsByAgency')
const GuichetsNews = () => import('@/views/models/guichets/GuichetsNews')
const GuichetsEdit = () => import('@/views/models/guichets/GuichetsEdit')
const GuichetsShow = () => import('@/views/models/guichets/GuichetsShow')

const Grilletarifaires = () => import('@/views/models/grilletarifaires/Grilletarifaires')
const GrilletarifairesNews = () => import('@/views/models/grilletarifaires/GrilletarifairesNews')
const GrilletarifairesEdit = () => import('@/views/models/grilletarifaires/GrilletarifairesEdit')
const GrilletarifairesShow = () => import('@/views/models/grilletarifaires/GrilletarifairesShow')

const Etat_Journal_Transactions = () => import('@/views/models/etats/Journal_transaction')
const Etat_Journal_Decaissement = () => import('@/views/models/etats/Decaissement')
const Etat_Tableau_Bord = () => import('@/views/models/etats/Tableau_Bord')
const Etat_Tableau_Bord_Distrib = () => import('@/views/models/etats/Tableau_Bord_Distrib')
// const TaxesNews = () => import('@/views/models/taxes/TaxesNews')
// const TaxesEdit = () => import('@/views/models/taxes/TaxesEdit')
// const TaxesShow = () => import('@/views/models/taxes/TaxesShow')

const Tarifications = () => import('@/views/models/tarifications/Tarifications')
const TarificationsByGrille = () => import('@/views/models/tarifications/TarificationsByGrille')
const TarificationsNews = () => import('@/views/models/tarifications/TarificationsNews')
const TarificationsEdit = () => import('@/views/models/tarifications/TarificationsEdit')
const TarificationsShow = () => import('@/views/models/tarifications/TarificationsShow')

const Plannings = () => import('@/views/models/plannings/Plannings')
const PlanningSolde = () => import('@/views/models/plannings/PlanningSolde')
const PlanningsByGuichet = () => import('@/views/models/plannings/PlanningsByGuichet')
const PlanningsByEntite = () => import('@/views/models/plannings/PlanningsByEntite')
const PlanningsByUser = () => import('@/views/models/plannings/PlanningsByUser')
const PlanningsNews = () => import('@/views/models/plannings/PlanningsNews')
const PlanningsByEntiteNews = () => import('@/views/models/plannings/PlanningsByEntiteNews')
const PlanningsShow = () => import('@/views/models/plannings/PlanningsShow')

const Typedepieces = () => import('@/views/models/typedepieces/Typedepieces')
const TypedepiecesNews = () => import('@/views/models/typedepieces/TypedepiecesNews')
const TypedepiecesEdit = () => import('@/views/models/typedepieces/TypedepiecesEdit')
const TypedepiecesShow = () => import('@/views/models/typedepieces/TypedepiecesShow')

const Typeoperations = () => import('@/views/models/typeoperations/Typeoperations')
const TypeoperationsNews = () => import('@/views/models/typeoperations/TypeoperationsNews')
const TypeoperationsEdit = () => import('@/views/models/typeoperations/TypeoperationsEdit')
const TypeoperationsShow = () => import('@/views/models/typeoperations/TypeoperationsShow')

const Typeoperations_Headers = () => import('@/views/models/typeoperations_headers/Typeoperations_Headers')
const TypeoperationsNews_Headers = () => import('@/views/models/typeoperations_headers/TypeoperationsNews_Headers')
const TypeoperationsEdit_Headers = () => import('@/views/models/typeoperations_headers/TypeoperationsEdit_Headers')
const TypeoperationsShow_Headers = () => import('@/views/models/typeoperations_headers/TypeoperationsShow_Headers')

const Commissions = () => import('@/views/models/commissions/Commissions')
const CommissionsByEntite = () => import('@/views/models/commissions/CommissionsByEntite')
const CommissionsByTypeOperation = () => import('@/views/models/commissions/CommissionsByTypeOperation')
const CommissionsNews = () => import('@/views/models/commissions/CommissionsNews')
const CommissionsEdit = () => import('@/views/models/commissions/CommissionsEdit')
const CommissionsShow = () => import('@/views/models/commissions/CommissionsShow')

const Approvisionnements = () => import('@/views/models/approvisionnements/Approvisionnements')
const ApprovisionnementsOwn = () => import('@/views/models/approvisionnements/ApprovisionnementsOwn')
const ApprovisionnementsUser = () => import('@/views/models/approvisionnements/ApprovisionnementsUser')
const ApprovisionnementsEntite = () => import('@/views/models/approvisionnements/ApprovisionnementsEntite')
const ApprovisionnementsbyAgence = () => import('@/views/models/approvisionnements/ApprovisionnementsbyAgence')
const ApprovisionnementsEntiteByEntity = () => import('@/views/models/approvisionnements/ApprovisionnementsEntiteByEntity')
const ApprovisionnementsGuichet = () => import('@/views/models/approvisionnements/ApprovisionnementsGuichet')
const ApprovisionnementsGuichetByGuichet = () => import('@/views/models/approvisionnements/ApprovisionnementsGuichetByGuichet')
const ApprovisionnementsEntiteNews = () => import('@/views/models/approvisionnements/ApprovisionnementsEntiteNews')
const ApprovisionnementsGuichetNews = () => import('@/views/models/approvisionnements/ApprovisionnementsGuichetNews')
const ApprovisionnementsShow = () => import('@/views/models/approvisionnements/ApprovisionnementsShow')

const Mandats = () => import('@/views/models/mandats/Mandats')
const MandatsOwn = () => import('@/views/models/mandats/MandatsOwn')
const MandatsOwnEntity = () => import('@/views/models/mandats/MandatsOwnEntity')
const MandatsByEntity = () => import('@/views/models/mandats/MandatsByEntity')
const MandatsByTypePiece = () => import('@/views/models/mandats/MandatsByTypePiece')
const MandatsByTypeOperation = () => import('@/views/models/mandats/MandatsByTypeOperation')
const MandatsByAgency = () => import('@/views/models/mandats/MandatsByAgency')
const MandatsByGuichet = () => import('@/views/models/mandats/MandatsByGuichet')
const MandatsUpdate = () => import('@/views/models/mandats/MandatsUpdate')
const MandatsByUser = () => import('@/views/models/mandats/MandatsByUser')
const TranfertsNews = () => import('@/views/models/mandats/MandatsNews')
const TranfertsRetraitNews = () => import('@/views/models/mandats/MandatsRetraitNews')
const MandatsAutorisation = () => import('@/views/models/mandats/MandatsAutorisation')
const MandatsDeblocage = () => import('@/views/models/mandats/MandatsDeblocage')
const MandatsAnnulation = () => import('@/views/models/mandats/MandatsAnnulation')
const PaiementMasseNews = () => import('@/views/models/mandats/PaiementMasseNews')
const PaiementMasse = () => import('@/views/models/mandats/PaiementMasse')
const PaiementRetraitNews = () => import('@/views/models/mandats/PaiementRetraitNews')
const MandatsShow = () => import('@/views/models/mandats/MandatsShow')
const PaiementsShow = () => import('@/views/models/mandats/PaiementMasseShow')
const MandatsModel = () => import('@/views/models/mandats/MandatsModel')
const MandatsModelNews = () => import('@/views/models/mandats/MandatsModelNews')
const MandatsModelEdit = () => import('@/views/models/mandats/MandatsModelEdit')

const Users = () => import('@/views/models/users/Users')
const UsersByEntity = () => import('@/views/models/users/UsersByEntity')
const UsersOwn = () => import('@/views/models/users/UsersOwn')
const UsersNews = () => import('@/views/models/users/UsersNews')
const UsersEdit = () => import('@/views/models/users/UsersEdit')
const UsersShow = () => import('@/views/models/users/UsersShow')

const Plafonds = () => import('@/views/models/plafonds/Plafonds')
const PlafondsNews = () => import('@/views/models/plafonds/PlafondsNews')
const PlafondsEdit = () => import('@/views/models/plafonds/PlafondsEdit')
const PlafondsAutorisation = () => import('@/views/models/plafonds/PlafondsAutorisation')
const DelaisNews = () => import('@/views/models/plafonds/DelaisNews')
const DelaisEdit = () => import('@/views/models/plafonds/DelaisEdit')

const Mouchards = () => import('@/views/models/mouchard/Mouchards')

const HistoEntities = () => import('@/views/models/historique/Entities')
const HistoAgencies = () => import('@/views/models/historique/Agencies')
const HistoGuichets = () => import('@/views/models/historique/Guichets')
const HistoAppro = () => import('@/views/models/historique/Approvisionnements')
const Histo= () => import('@/views/models/historique/Historiques')
Vue.use(Router)


export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard/reloader/false',
      name: 'Dashboard',
      component: DefaultContainer,      
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard/reloader/:reload_option',
          name: 'Dashboard',
          component: Dashboard,
          meta: { requiresAuth: true }
        },
        {
          path: 'entites',
          redirect: '/entites/list',
          name: 'Entites',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des entités',
              component: Entities,
              meta: { requiresAuth: true }
            },
            {
              path: 'create',
              name: 'Ajout',
              component: EntitiesNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification',
              component: EntitiesEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détails',
              component: EntitiesShow,
              props:true,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'delais',
          redirect: '/delais/list',
          name: 'Delais',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            // {
            //   path: 'list',
            //   name: 'Delais des retraits',
            //   component: Delais,
            //   meta: { requiresAuth: true }
            // },
            {
              path: 'create',
              name: 'Ajout',
              component: DelaisNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit',
              name: 'Modification',
              component: DelaisEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détails',
              component: EntitiesShow,
              props: true,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'plafonds',
          redirect: '/plafonds/list',
          name: 'Plafonds',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des plafonds',
              component: Plafonds,
              meta: { requiresAuth: true }
            },
            {
              path: 'create',
              name: 'Ajout',
              component: PlafondsNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'autorisation',
              name: 'Autorisation d\'un plafond',
              component: PlafondsAutorisation,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification',
              component: PlafondsEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détails',
              component: EntitiesShow,
              props: true,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'agences',
          redirect: '/agences/agences-own',
          name: 'Agences',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des agences',
              component: Agences,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/entite/:entite_id',
              name: 'Liste des agences par entité',
              component: AgencesByEntity,
              meta: { requiresAuth: true }
            },
            {
              path: 'agences-own',
              name: 'Mes agences',
              component: AgencesOwn,
              meta: { requiresAuth: true }
            },
            {
              path: 'create/entite/:entite_id',
              name: 'Ajout d\'une agence',
              component: AgencesNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification d\'une agence',
              component: AgencesEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détails d\'une agence',
              component: AgencesShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'guichets',
          redirect: '/guichets/guichets-own',
          name: 'Guichets',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des guichets',
              component: Guichets,
              meta: { requiresAuth: true }
            },
            {
              path: 'guichets-own',
              name: 'Mes guichets',
              component: GuichetsOwn,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/agence/:agence_id',
              name: 'Liste des guichets par agence',
              component: GuichetsAgency,
              meta: { requiresAuth: true }
            },
            {
              path: 'create/agence/:agence_id',
              name: 'Ajout d\'un guichet',
              component: GuichetsNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification du guichet',
              component: GuichetsEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détail d\'un guichet',
              component: GuichetsShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'grilletarifaires',
          redirect: '/grilletarifaires/list',
          name: 'Grilles tarifaires',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des grilles tarifaires',
              component: Grilletarifaires,
              meta: { requiresAuth: true }
            },
            {
              path: 'create/',
              name: 'Ajout d\'une grille tarifaire',
              component: GrilletarifairesNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification d\'une grille tarifaire',
              component: GrilletarifairesEdit,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'historique',
          redirect: '/historique/entite/:entite_id',
          name: 'Historique',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            // {
            //   path: 'entite/:entite_id',
            //   name: 'Historique de l\'entité',
            //   component: HistoEntities,
            //   meta: { requiresAuth: true }
            // },
            // {
            //   path: 'agence/:agence_id',
            //   name: 'Historique d\'une agence',
            //   component: HistoAgencies,
            //   meta: { requiresAuth: true }
            // },
            // {
            //   path: 'guichet/:guichet_id',
            //   name: 'Historique d\'un guichet',
            //   component: HistoGuichets,
            //   meta: { requiresAuth: true }
            // },
            // {
            //   path: 'approvisionnements/:approvisionnement_id',
            //   name: 'Historique d\'un approvisionnement',
            //   component: HistoAppro,
            //   meta: { requiresAuth: true }
            // },
            {
              path: ':name_model/:id_model',
              name: 'Historique',
              component: Histo,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'commisions_speciales',
          redirect: '/commisions_speciales/list',
          name: 'Liste des commisions spéciales',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des commisions spéciales',
              component: Commissions,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/entite/:entite_id',
              name: 'Liste des commisions spéciales par entité',
              component: CommissionsByEntite,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/typeoperation/:typeoperation_code',
              name: 'Liste des commisions spéciales par type opération',
              component: CommissionsByTypeOperation,
              meta: { requiresAuth: true }
            },
            {
              path: 'create/entite/:entite_id/typeoperation/:typeoperation_code',
              name: 'Ajout d\'une commision spéciale',
              component: CommissionsNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification d\'une commission spéciale',
              component: CommissionsEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détail d\'une commision spéciale',
              component: CommissionsShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'tarifications',
          redirect: '/tarifications/list',
          name: 'Tarifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des tarifications',
              component: Tarifications,
              meta: { requiresAuth: true }
            },
            {
              path: 'grilletarifaire/list/:grilletarifaire_libelle',
              name: 'liste des tarifications par grille',
              component: TarificationsByGrille,
              meta: { requiresAuth: true }
            },
            {
              path: 'grilletarifaire/create/:grilletarifaire_libelle',
              name: 'Ajout d\'une tarification',
              component: TarificationsNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification d\'une tarification',
              component: TarificationsEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détail de la tarification',
              component: TarificationsShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'plannings',
          redirect: '/plannings/list',
          name: 'Plannings',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des plannings',
              component: Plannings,
              meta: { requiresAuth: true }
            },
            {
              path: 'solde',
              name: 'Soldes',
              component: PlanningSolde,
              meta: { requiresAuth: true }
            },
            {
              path: 'guichet/list/:guichet_id',
              name: 'Plannings par guichet ',
              component: PlanningsByGuichet,
              meta: { requiresAuth: true }
            },
            {
              path: 'user/list/:user_id',
              name: 'Plannings par utilisateur',
              component: PlanningsByUser,
              meta: { requiresAuth: true }
            },
            {
              path: 'guichet/create/:guichet_id',
              name: 'Ajout d\'un planning',
              component: PlanningsNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'heures_ouvertures/parametrage',
              name: 'Paramétrage des heures d\'ouverture',
              component: PlanningsByEntiteNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'heures_ouvertures',
              name: 'Heures d\'ouverture',
              component: PlanningsByEntite,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Modification d\'un planning',
              component:PlanningsShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'typedepieces',
          redirect: '/typedepieces/list',
          name: 'Types de pièces',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des types de pièces',
              component: Typedepieces,
              meta: { requiresAuth: true }
            },
            {
              path: 'create',
              name: 'Ajout d\'un type de pièce',
              component: TypedepiecesNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:libelle',
              name: 'Modification d\'un type de pièce',
              component: TypedepiecesEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détail du type de pièces',
              component: TypedepiecesShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'entete',
          redirect: '/entete/list',
          name: 'Liste des entêtes de types d\'opérations',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des entêtes de types d\'opérations',
              component: Typeoperations_Headers,
              meta: { requiresAuth: true }
            },
            {
              path: 'create',
              name: 'Ajout d\'une entête d\'un type d\'opérations',
              component: TypeoperationsNews_Headers,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification d\'une entête d\'un type d\'opérations',
              component: TypeoperationsEdit_Headers,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détails d\'une entête du type d\'opérations',
              component: TypeoperationsShow_Headers,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'typeoperations',
          redirect: '/typeoperations/list',
          name: 'Type d\'opérations',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des types d\'opérations',
              component: Typeoperations,
              meta: { requiresAuth: true }
            },
            {
              path: 'create',
              name: 'Ajout d\'un type d\'opérations',
              component: TypeoperationsNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification d\'un type d\'opérations',
              component: TypeoperationsEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détails du type d\'opérations',
              component: TypeoperationsShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'approvisionnements',
          redirect: '/approvisionnements/list',
          name: 'Approvisionnements',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des approvisionnements',
              component: Approvisionnements,
              meta: { requiresAuth: true }
            },
            {
              path: 'entite/list/:entite_id',
              name: 'Liste des approvisionnements par entité',
              component: ApprovisionnementsEntiteByEntity,
              meta: { requiresAuth: true }
            },
            {
              path: 'agence/list/:agence_id',
              name: 'Liste des approvisionnements par agence',
              component: ApprovisionnementsbyAgence,
              meta: { requiresAuth: true }
            },
            {
              path: 'approvisionnements-own',
              name: 'Mes approvisionnements',
              component: ApprovisionnementsOwn,
              meta: { requiresAuth: true }
            },
            {
              path: 'user/list/:user_id',
              name: 'Liste des approvionnements par utilisateurs',
              component: ApprovisionnementsUser,
              meta: { requiresAuth: true }
            },
            {
              path: 'entite',
              name: 'Liste des approvisionnements des entités',
              component: ApprovisionnementsEntite,
              meta: { requiresAuth: true }
            },
            {
              path: 'guichet',
              name: 'Liste des approvisionnements des guichets',
              component: ApprovisionnementsGuichet,
              meta: { requiresAuth: true }
            },
            {
              path: 'guichet/list/:guichet_id',
              name: 'Liste des approvisionnements par guichets',
              component: ApprovisionnementsGuichetByGuichet,
              meta: { requiresAuth: true }
            },
            {
              path: 'entite/create/:entite_id',
              name: 'Approvisionnement de l\'entité',
              component: ApprovisionnementsEntiteNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'guichet/create/:guichet_id',
              name: 'Approvisionnement du guichet',
              component: ApprovisionnementsGuichetNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'approvisionnements/show/:id',
              name: 'ApprovisionnementsShow',
              component: ApprovisionnementsShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'transferts',
          redirect: '/transferts/list',
          name: 'Transferts',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des opérations',
              component: Mandats,
              meta: { requiresAuth: true }
            },
            {
              path: 'transferts-own',
              name: 'Liste de mes opérations',
              component: MandatsOwn,
              meta: { requiresAuth: true }
            },
            {
              path: 'transferts-own-entity',
              name: 'Liste de mes opérations',
              component: MandatsOwnEntity,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/agence/:agence_id',
              name: 'Liste des opérations par agence',
              component: MandatsByAgency,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/entity/:entity_id',
              name: 'Liste des opérations par entité',
              component: MandatsByEntity,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/typedepieces/:typedepiece_id',
              name: 'Liste des opérations par type de pieces',
              component: MandatsByTypePiece,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/typeoperations/:typeoperation_id',
              name: 'Liste des opérations par type d\'opération',
              component: MandatsByTypeOperation,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/guichet/:guichet_id',
              name: 'Liste des opérations par guichet',
              component: MandatsByGuichet,
              meta: { requiresAuth: true }
            },
            {
              path: 'list/user/:user_id',
              name: 'Liste des opérations par utilisateur',
              component: MandatsByUser,
              meta: { requiresAuth: true }
            },
            {
              path: 'envoi/guichet/create/:guichet_id',
              name: 'Tranfert d\'argent',
              component: TranfertsNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'retrait/guichet/create/:guichet_id',
              name: 'Retrait d\'argent',
              component: TranfertsRetraitNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'autorisation/annulation',
              name: 'Autorisation d\'annulation',
              component: MandatsAutorisation,
              meta: { requiresAuth: true }
            },
            {
              path: 'deblocage',
              name: 'Déblocage',
              component: MandatsDeblocage,
              meta: { requiresAuth: true }
            },
            {
              path: 'update/beneficiare/:id_mandat',
              name: 'Modification des informations du bénéficiaire',
              component: MandatsUpdate,
              meta: { requiresAuth: true }
            },
            {
              path: 'annulation',
              name: 'Annulation d\'opérations',
              component: MandatsAnnulation,
              meta: { requiresAuth: true }
            },
            {
              path: 'paiement-masse/list',
              name: 'Affichage des paiements de masse',
              component: PaiementMasse,
              meta: { requiresAuth: true }
            },
            {
              path: 'paiement-masse/guichet/create/:guichet_id',
              name: 'Paiement de masse',
              component: PaiementMasseNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'paiement-masse/retrait',
              name: 'Retrait du paiement de masse',
              component: PaiementRetraitNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détails de l\'opérations',
              component: MandatsShow,
              meta: { requiresAuth: true }
            },
            {
              path: 'paiement/show/:id',
              name: 'Détails du paiement de masse',
              component: PaiementsShow,
              meta: { requiresAuth: true }
            },
            {
              path: 'paiement-masse/model',
              name: 'Modèle des paiements de masse',
              component: MandatsModel,
              meta: { requiresAuth: true }
            },
            {
              path: 'paiement-masse/model/new',
              name: 'Ajout d\'un model',
              component: MandatsModelNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'paiement-masse/model/edit/:id_model',
              name: 'Modification d\'un model',
              component: MandatsModelEdit,
              meta: { requiresAuth: true }
            },
          ]
        },
        {
          path: 'users',
          redirect: '/users/list',
          name: 'Utilisateurs',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Liste des utilisateurs',
              component: Users,
              meta: { requiresAuth: true }
            },
            {
              path: 'entite/list/:entite_id',
              name: 'Liste des utilisateurs par entité',
              component: UsersByEntity,
              meta: { requiresAuth: true }
            },
            {
              path: 'users-own',
              name: 'Mes utilisateurs',
              component: UsersOwn,
              meta: { requiresAuth: true }
            },
            {
              path: 'entite/create/:entite_id',
              name: 'Ajout d\'un utlisateur',
              component: UsersNews,
              meta: { requiresAuth: true }
            },
            {
              path: 'edit/:id',
              name: 'Modification d\'un utilisateur',
              component: UsersEdit,
              meta: { requiresAuth: true }
            },
            {
              path: 'show/:id',
              name: 'Détails d\'un utilisateur',
              component: UsersShow,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: 'etat/journal/transactions',
          name: 'Journal des transctions',
          component: Etat_Journal_Transactions
        },
        {
          path: 'etat/tableau_bord/general',
          name: 'Tableau de bord général',
          component: Etat_Tableau_Bord
        },
        {
          path: 'etat/tableau_bord/distributeur',
          name: 'Tableau de bord',
          component: Etat_Tableau_Bord_Distrib
        },
        {
          path: 'etat/journal/decaissements',
          name: 'Journal des décaissements',
          component: Etat_Journal_Decaissement
        },
        {
          path: 'mouchards',
          name: 'Mouchards de sessions',
          component: Mouchards
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users,
            },
            {
              path: ':id',
              meta: { label: 'User Details'},
              name: 'User',
              component: User,
            },
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'CoreUI Icons',
              component: CoreUIIcons
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            },
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },        
        {
          path: 'secret-code',
          name: 'SecretCode',
          component: SecretCode
        },        
        {
          path: 'keycloak-redirect',
          name: 'Keycloak',
          component: Keycloak
        },        
        {
          path: 'forget-password',
          name: 'forgetPassword',
          component: ForgetPassword
        },        
        {
          path: 'reset-password/:token',
          name: 'resetPassword',
          component: ResetPassword
        },        
        {
          path: 'logout',
          name: 'Logout',
          component: Logout
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
});
